











































































































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
  computed,
} from '@vue/composition-api'

import { editMediaItem } from '@/shared/api'
import CloseButton from '@/components/custom/CloseButton.vue'
import { EditMediaItemRequestData } from '@/shared/types'
import { licensesSymbol } from '@/shared/state-management/symbols'

export default defineComponent({
  name: 'EditMediaItem',
  components: {
    CloseButton,
  },
  props: {
    textbook: Object,
    textbooks: Array,
    mediaItem: Object,
  },
  setup(props, { root, emit }) {
    const MediaUploadForm = ref(null)
    const data = reactive({
      valid: true,
      name: props.mediaItem.name,
      nameRules: [() => true || 'name.required'],
      description: props.mediaItem.description,
      descriptionRules: [() => true || 'description.required'],
      licenses: props.mediaItem.licenses ? props.mediaItem.licenses : [],
      category: props.mediaItem.category ? props.mediaItem.category.id : null,
      isDownloadable: props.mediaItem.isDownloadable,
      type: props.mediaItem.type,
    } as EditMediaItemRequestData)
    const selectedTextbook = ref(props.textbook)

    const loadingData = ref(false)
    const availableLicenses = inject(licensesSymbol) as { value: Array<string> }
    const availableTypes = computed(() => [
      {
        label: root.$t('mediaItem.type.audio'),
        value: 'audio',
      },
      {
        label: root.$t('mediaItem.type.video'),
        value: 'video',
      },
      {
        label: root.$t('mediaItem.type.pdf'),
        value: 'pdf',
      },
      {
        label: root.$t('mediaItem.type.pdf'),
        value: 'pdf',
      },
      {
        label: root.$t('mediaItem.type.image'),
        value: 'image',
      },
      {
        label: root.$t('mediaItem.type.excel'),
        value: 'excel',
      },
      {
        label: root.$t('mediaItem.type.word'),
        value: 'word',
      },
      {
        label: root.$t('mediaItem.type.zip'),
        value: 'zip',
      },
      {
        label: root.$t('mediaItem.type.link'),
        value: 'link',
      },
      {
        label: root.$t('mediaItem.type.other'),
        value: 'other',
      },
    ])

    const submit = async () => {
      const form = MediaUploadForm.value
      form.validate()
      const newMediaItem = await editMediaItem(props.mediaItem.id, data)
      emit('media-item-edited', newMediaItem)
    }

    return {
      ...toRefs(data),
      selectedTextbook,
      loadingData,
      MediaUploadForm,
      availableTypes,
      availableLicenses,
      submit,
    }
  },
})
